import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import LoaderReducer from './reducers/Loader.reducer';
import UserReducer from '@core/reducers/user.reducer';
import { ModalReducer } from '@core/reducers/modal.reducer';
import { ModalReducer as ModalOverScreenReducer } from '@shared/reducers/Modal.reducer';

export const store = configureStore({
  reducer: {
    loader: LoaderReducer,
    user: UserReducer,
    modal: ModalReducer,
    modalOverScreen: ModalOverScreenReducer,
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
  RootState,
  unknown,
  Action<string>>;
